import Nullstack from 'nullstack';
export default function IconBrandZapier({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-zapier",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h6"
  }), "   ", Nullstack.element("path", {
    d: "M21 12h-6"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v6"
  }), "   ", Nullstack.element("path", {
    d: "M12 15v6"
  }), "   ", Nullstack.element("path", {
    d: "M5.636 5.636l4.243 4.243"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 18.364l-4.243 -4.243"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 5.636l-4.243 4.243"
  }), "   ", Nullstack.element("path", {
    d: "M9.879 14.121l-4.243 4.243"
  }), " ");
}